var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgDocumentsLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 31.305,
    viewBox: "0 0 24 31.305"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-documents-link_svg__cls-2{stroke:#fff;stroke-width:1.6px;fill:none;stroke-linecap:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-link_svg__ICN_Documente_Enabled",
    transform: "translate(-427 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-link_svg__Group_611",
    "data-name": "Group 611",
    transform: "translate(427 316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-link_svg__Rectangle_151",
    "data-name": "Rectangle 151",
    strokeWidth: 1.6,
    stroke: "#fff",
    fill: "#004a9b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 31.304,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 22.4,
    height: 29.704,
    rx: 3.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-link_svg__Line_34",
    "data-name": "Line 34",
    className: "kpmg-documents-link_svg__cls-2",
    transform: "translate(6.783 5.696)",
    d: "M0 0h10.435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-link_svg__Line_35",
    "data-name": "Line 35",
    className: "kpmg-documents-link_svg__cls-2",
    transform: "translate(7.826 8.826)",
    d: "M0 0h8.348"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-link_svg__Line_37",
    "data-name": "Line 37",
    className: "kpmg-documents-link_svg__cls-2",
    transform: "translate(9.271 15.087)",
    d: "M0 0h10.162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-link_svg__Line_39",
    "data-name": "Line 39",
    className: "kpmg-documents-link_svg__cls-2",
    transform: "translate(4.652 18.347)",
    d: "M0 0h6.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-link_svg__Line_43",
    "data-name": "Line 43",
    stroke: "#30acec",
    strokeLinecap: "round",
    fill: "none",
    strokeWidth: 1.6,
    d: "M13.043 26.652h6.261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-link_svg__Line_41",
    "data-name": "Line 41",
    className: "kpmg-documents-link_svg__cls-2",
    transform: "translate(4.652 15.087)",
    d: "M0 0h1.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-link_svg__Line_40",
    "data-name": "Line 40",
    className: "kpmg-documents-link_svg__cls-2",
    transform: "translate(13.5 18.347)",
    d: "M0 0h5.933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-link_svg__Line_42",
    "data-name": "Line 42",
    className: "kpmg-documents-link_svg__cls-2",
    transform: "translate(4.652 21.478)",
    d: "M0 0h7.391"
  })))));
}

export default SvgKpmgDocumentsLink;